import axiosInstance from '@/utils/api.js'

var state = {
  ramMemoryStat: [],
  topProcessStatisticsMEM: [],
  topProcessStatisticsCPU: [],
  dataBaseProcesses: [],
  dataBaseStat: [],
  customerPortalModuleConnections: [],
  statCreatedUsers: [],
  statDeletedUsers: [],
  tariffsHistory: [],
  tariffsHistoryGraphic: [],
  coreConnections: [],
  radiusSessions: [],
  restConnections: [],
  hotspotSessions: [],
  coreInfo: [],
  rs_total_rows: []
}

var getters = {
  RAM_MEMORY_STAT: (state) => {
    return state.ramMemoryStat
  },
  TOP_PROCESS_STATISTICS_MEM: (state) => {
    return state.topProcessStatisticsMEM
  },
  TOP_PROCESS_STATISTICS_CPU: (state) => {
    return state.topProcessStatisticsCPU
  },
  DATA_BASE_PROCESSES: (state) => {
    return state.dataBaseProcesses
  },
  DATA_BASE_STAT: (state) => {
    return state.dataBaseStat
  },
  CUSTOMER_PORTAL_MODULE_CONNECTIONS: (state) => {
    return state.customerPortalModuleConnections
  },
  STAT_CREATED_USERS: (state) => {
    return state.statCreatedUsers
  },
  STAT_DELETED_USERS: (state) => {
    return state.statDeletedUsers
  },
  TARIFFS_HISTORY: (state) => {
    return state.tariffsHistory
  },
  TARIFFS_HISTORY_GRAPHIC: (state) => {
    return state.tariffsHistoryGraphic
  },
  CORE_CONNECTIONS: (state) => {
    return state.coreConnections
  },
  RADIUS_SESSIONS: (state) => {
    return state.radiusSessions
  },
  RADIUS_SESSIONS_TOTAL_ROWS: (state) => {
    return state.rs_total_rows
  },
  REST_CONNECTIONS: (state) => {
    return state.restConnections
  },
  HOTSPOT_SESSIONS: (state) => {
    return state.hotspotSessions
  },
  CORE_INFO: (state) => {
    return state.coreInfo
  }
}

var mutations = {
  SET_RAM_MEMORY_STAT: (state, payload) => {
    state.ramMemoryStat = payload
  },
  SET_TOP_PROCESS_STATISTICS_MEM: (state, payload) => {
    state.topProcessStatisticsMEM = payload
  },
  SET_TOP_PROCESS_STATISTICS_CPU: (state, payload) => {
    state.topProcessStatisticsCPU = payload
  },
  SET_DATA_BASE_PROCESSES: (state, payload) => {
    state.dataBaseProcesses = payload
  },
  SET_DATA_BASE_STAT: (state, payload) => {
    state.dataBaseStat = payload
  },
  SET_CUSTOMER_PORTAL_MODULE_CONNECTIONS: (state, payload) => {
    state.customerPortalModuleConnections = payload
  },
  SET_STAT_CREATED_USERS: (state, payload) => {
    state.statCreatedUsers = payload
  },
  SET_STAT_DELETED_USERS: (state, payload) => {
    state.statDeletedUsers = payload
  },
  SET_TARIFFS_HISTORY: (state, payload) => {
    state.tariffsHistory = payload
  },
  SET_TARIFFS_HISTORY_GRAPHIC: (state, payload) => {
    state.tariffsHistoryGraphic = payload
  },
  SET_CORE_CONNECTIONS: (state, payload) => {
    state.coreConnections = payload
  },
  SET_RADIUS_SESSIONS: (state, payload) => {
    state.radiusSessions = payload.sessions
    state.rs_total_rows = payload.total_rows
  },
  SET_REST_CONNECTIONS: (state, payload) => {
    state.restConnections = payload
  },
  SET_HOTSPOT_SESSIONS: (state, payload) => {
    state.hotspotSessions = payload
  },
  SET_CORE_INFO: (state, payload) => {
    state.coreInfo = payload
  }
}

var actions = {
  GET_RAM_MEMORY_STAT: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/ram_stat')
    if (result.status === 200) {
      context.commit('SET_RAM_MEMORY_STAT', result.data)
    }
  },
  GET_TOP_PROCESS_STATISTICS_MEM: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/top_processes?sort_type=mem')
    if (result.status === 200) {
      context.commit('SET_TOP_PROCESS_STATISTICS_MEM', result.data)
    }
  },
  GET_TOP_PROCESS_STATISTICS_CPU: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/top_processes?sort_type=cpu')
    if (result.status === 200) {
      context.commit('SET_TOP_PROCESS_STATISTICS_CPU', result.data)
    }
  },
  GET_DATA_BASE_PROCESSES: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/db_processes')
    if (result.status === 200) {
      context.commit('SET_DATA_BASE_PROCESSES', result.data)
    }
  },
  GET_DATA_BASE_STAT: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/db_stats')
    if (result.status === 200) {
      context.commit('SET_DATA_BASE_STAT', result.data)
    }
  },
  GET_CUSTOMER_PORTAL_MODULE_CONNECTIONS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/cp_connections')
    context.commit('SET_CUSTOMER_PORTAL_MODULE_CONNECTIONS', result.data)
  },
  GET_STAT_CREATED_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/stat_created_users')
    if (result.status === 200) {
      context.commit('SET_STAT_CREATED_USERS', result.data)
    }
  },
  GET_STAT_DELETED_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/stat_deleted_users')
    if (result.status === 200) {
      context.commit('SET_STAT_DELETED_USERS', result.data)
    }
  },
  GET_TARIFFS_HISTORY: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/tariffs_history?data_from=' + payload.dateFrom + '&data_to=' + payload.dateTo)
    if (result.status === 200) {
      context.commit('SET_TARIFFS_HISTORY', result.data)
    }
  },
  GET_TARIFFS_HISTORY_GRAPHIC: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/tariffs_history_graphic?data_from=' + payload.dateFrom + '&data_to=' + payload.dateTo)
    if (result.status === 200) {
      context.commit('SET_TARIFFS_HISTORY_GRAPHIC', result.data)
    }
  },
  GET_CORE_CONNECTIONS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/core_connections')
    if (result.status === 200) {
      context.commit('SET_CORE_CONNECTIONS', result.data)
    }
  },
  GET_RADIUS_SESSIONS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/radius_sessions?page=' + payload.page + '&per_page=' + payload.perPage + '&filter=' + payload.filter)
    if (result.status === 200) {
      context.commit('SET_RADIUS_SESSIONS', result.data)
    }
  },
  GET_REST_CONNECTIONS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/rest_connections')
    if (result.status === 200) {
      context.commit('SET_REST_CONNECTIONS', result.data)
    }
  },
  GET_HOTSPOT_SESSIONS: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/hotspot_sessions')
    if (result.status === 200) {
      context.commit('SET_HOTSPOT_SESSIONS', result.data)
    }
  },
  GET_CORE_INFO: async (context, payload) => {
    let result = await axiosInstance.get('/dashboard/core_build_info')
    if (result.status === 200) {
      context.commit('SET_CORE_INFO', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/dashboard.js